module.exports = __webpack_public_path__ + "img/yuyuko saigyouji tiny ghost mistress_lw.1b2adc8e.png";